export default __webpack_public_path__ + "static/media/026-steamed fish.f1205090.svg";